import { Cached } from "@mui/icons-material";
import { Autocomplete, Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, OutlinedInput, styled, TextField, Typography } from "@mui/material"
import { Mounting, Shielding } from "../../../../../common/const";

const DefaultTypo = styled(Typography)(({ theme }) => ({
  color: 'gray',
  fontSize: 10
}));

const DefaultTypo1 = styled(Typography)(({ theme }) => ({
  color: 'red',
  fontSize: 10
}));

const Physical = ({
  itemData,
  items,
  setItems,
  projectData
}) => {
  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>Physical Specifications</Typography>
          <Typography variant="body2" sx={{ fontSize: 12 }}>Dimensions, clearance, weight and other physical attributes.</Typography>
        </Box>
        <Box>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<Cached />}
            onClick={() => {
              setItems((prevData) => ({
                ...prevData,
                product_data: {
                  ...prevData.product_data,
                  description: itemData?.product?.description,
                  adjustable_width: itemData?.product?.adjustable_width,
                  adjustable_height: itemData?.product?.adjustable_height,
                  adjustable_depth: itemData?.product?.adjustable_depth,
                  width: itemData?.product?.width,
                  height: itemData?.product?.height,
                  depth: itemData?.product?.depth,
                  mounting: itemData?.product?.mounting,
                  max_weight: itemData?.product?.max_weight,
                  ship_weight: itemData?.product?.ship_weight,
                  clearance: {
                    left: itemData?.product?.clearance?.left,
                    right: itemData?.product?.clearance?.right,
                    front: itemData?.product?.clearance?.front,
                    back: itemData?.product?.clearance?.back,
                    top: itemData?.product?.clearance?.top,
                    bottom: itemData?.product?.clearance?.bottom
                  },
                  da_complient: itemData?.product?.da_complient,
                  antimicrobial: itemData?.product?.antimicrobial,
                  green: itemData?.product?.green,
                  seismic: itemData?.product?.seismic,
                  Shielding: itemData?.product?.Shielding,
                  spatial_remarks: itemData?.product?.spatial_remarks
                }
              }));
            }}
          >
            Reset Section
          </Button>
        </Box>
      </Box>
      <Grid container spacing={2} mt={0.5}>
        <Grid item sm={12} md={6}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Product Long Description</InputLabel>
            <OutlinedInput
              label="Product Long Description"
              id="standard-adornment-password"
              type='text'
              multiline
              minRows={5}
              maxRows={5}
              sx={{
                fontSize: 12,
              }}
              value={items?.product_data?.description || ''}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  product_data: {
                    ...prevData.product_data,
                    description: e.target.value || null
                  }
                }));
              }}
            />
          </FormControl>
          {items?.product_data?.description !== itemData?.product?.description && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.description || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item sm={12} md={6}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel htmlFor="standard-adornment-password">Spatial Remarks</InputLabel>
            <OutlinedInput
              label="Spatial Remarks"
              id="standard-adornment-password"
              type='text'
              multiline
              minRows={5}
              maxRows={5}
              sx={{
                fontSize: 12,
              }}
              value={items?.product_data?.spatial_remarks || ''}
              onChange={(e) => {
                setItems((prevData) => ({
                  ...prevData,
                  product_data: {
                    ...prevData.product_data,
                    spatial_remarks: e.target.value || null
                  }
                }));
              }}
            />
          </FormControl>
          {items?.product_data?.spatial_remarks !== itemData?.product?.spatial_remarks && (
            <Box display="flex" alignItems="center">
              <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
              <DefaultTypo1 variant="body2">{itemData?.product?.spatial_remarks || '--'}</DefaultTypo1>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={3}>
          <Box style={{ marginTop: 10, paddingBottom: 10 }}>
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Dimensions</Typography>
          </Box>
          <Grid container spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormControl size="small" fullWidth variant="outlined">
                <InputLabel htmlFor="standard-adornment-password">Width ({projectData?.default_project_units === 'matric' ? 'mm' : 'in'})</InputLabel>
                <OutlinedInput
                  label={`Width (${projectData?.default_project_units === 'matric' ? 'mm' : 'in'})`}
                  id="standard-adornment-password"
                  type='number'
                  value={items?.product_data?.width}
                  onChange={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        width: e.target.value || null
                      }
                    }));
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 38 || event.keyCode === 40) {
                      event.preventDefault();
                    }
                  }}
                />
              </FormControl>
              {items?.product_data?.width !== itemData?.product?.width && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.width || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormControl size="small" fullWidth variant="outlined">
                <InputLabel htmlFor="standard-adornment-password">Height ({projectData?.default_project_units === 'matric' ? 'mm' : 'in'})</InputLabel>
                <OutlinedInput
                  label={`Height (${projectData?.default_project_units === 'matric' ? 'mm' : 'in'})`}
                  id="standard-adornment-password"
                  type='number'
                  value={items?.product_data?.height}
                  onChange={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        height: e.target.value || null
                      }
                    }));
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 38 || event.keyCode === 40) {
                      event.preventDefault();
                    }
                  }}
                />
              </FormControl>
              {items?.product_data?.height !== itemData?.product?.height && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.height || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormControl size="small" fullWidth variant="outlined">
                <InputLabel htmlFor="standard-adornment-password">Depth ({projectData?.default_project_units === 'matric' ? 'mm' : 'in'})</InputLabel>
                <OutlinedInput
                  label={`Depth (${projectData?.default_project_units === 'matric' ? 'mm' : 'in'})`}
                  id="standard-adornment-password"
                  type='number'
                  value={items?.product_data?.depth}
                  onChange={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        depth: e.target.value || null
                      }
                    }));
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 38 || event.keyCode === 40) {
                      event.preventDefault();
                    }
                  }}
                />
              </FormControl>
              {items?.product_data?.depth !== itemData?.product?.depth && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.depth || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={items?.product_data?.adjustable_width}
                      onClick={(e) => {
                        setItems((prevData) => ({
                          ...prevData,
                          product_data: {
                            ...prevData.product_data,
                            adjustable_width: e.target.checked || null
                          }
                        }));
                      }}
                    />}
                  label="Adjustable Width"
                />
              </FormGroup>
              {items?.product_data?.adjustable_width !== itemData?.product?.adjustable_width && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.adjustable_width ? 'Yes' : 'No'}</DefaultTypo1>
                </Box>
              )}
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={items?.product_data?.adjustable_depth}
                      onClick={(e) => {
                        setItems((prevData) => ({
                          ...prevData,
                          product_data: {
                            ...prevData.product_data,
                            adjustable_depth: e.target.checked || null
                          }
                        }));
                      }}
                    />}
                  label="Adjustable Depth"
                />
              </FormGroup>
              {items?.product_data?.adjustable_depth !== itemData?.product?.adjustable_depth && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.adjustable_depth || '--'}</DefaultTypo1>
                </Box>
              )}
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={items?.product_data?.adjustable_height}
                      onClick={(e) => {
                        setItems((prevData) => ({
                          ...prevData,
                          product_data: {
                            ...prevData.product_data,
                            adjustable_height: e.target.checked || null
                          }
                        }));
                      }}
                    />}
                  label="Adjustable Height"
                />
              </FormGroup>
              {items?.product_data?.adjustable_height !== itemData?.product?.adjustable_height && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.adjustable_height ? 'Yes' : 'No'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={3}>
          <Box style={{ marginTop: 10, paddingBottom: 10 }}>
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Weights</Typography>
          </Box>
          <Grid container spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Autocomplete
                value={Mounting.find((c) => c.value === items?.product_data?.mounting) || null}
                id="combo-box-demo"
                size="small"
                fullWidth
                options={Mounting}
                getOptionLabel={(option) => option?.name}
                onChange={(event, newValue) => {
                  setItems((prevData) => ({
                    ...prevData,
                    product_data: {
                      ...prevData.product_data,
                      mounting: newValue?.value || null
                    }
                  }));
                }}
                renderInput={(params) => <TextField fullWidth {...params} label="Mounting" name="Mounting" variant="outlined" />}
              />
              {items?.product_data?.mounting !== itemData?.product?.mounting && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{Mounting.find((c) => c.value === itemData?.product?.mounting)?.name || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormControl size="small" fullWidth variant="outlined">
                <InputLabel htmlFor="standard-adornment-password">Weight ({projectData?.default_project_units === 'matric' ? 'kg' : 'lbs'})</InputLabel>
                <OutlinedInput
                  label={`Weight (${projectData?.default_project_units === 'matric' ? 'kg' : 'lbs'})`}
                  id="standard-adornment-password"
                  type='number'
                  value={items?.product_data?.max_weight}
                  onChange={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        max_weight: e.target.value || null
                      }
                    }));
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 38 || event.keyCode === 40) {
                      event.preventDefault();
                    }
                  }}
                />
              </FormControl>
              {items?.product_data?.max_weight !== itemData?.product?.max_weight && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.max_weight || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormControl size="small" fullWidth variant="outlined">
                <InputLabel htmlFor="standard-adornment-password">Ship Weight ({projectData?.default_project_units === 'matric' ? 'kg' : 'lbs'})</InputLabel>
                <OutlinedInput
                  label={`Ship Weight (${projectData?.default_project_units === 'matric' ? 'kg' : 'lbs'})`}
                  id="standard-adornment-password"
                  type='number'
                  value={items?.product_data?.ship_weight}
                  onChange={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        ship_weight: e.target.value || null
                      }
                    }));
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 38 || event.keyCode === 40) {
                      event.preventDefault();
                    }
                  }}
                />
              </FormControl>
              {items?.product_data?.ship_weight !== itemData?.product?.ship_weight && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.ship_weight || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={3}>
          <Box style={{ marginTop: 10, paddingBottom: 10 }}>
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Clearance</Typography>
          </Box>
          <Grid container spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormControl size="small" fullWidth variant="outlined">
                <InputLabel htmlFor="standard-adornment-password">Left ({projectData?.default_project_units === 'matric' ? 'mm' : 'in'})</InputLabel>
                <OutlinedInput
                  label={`Left (${projectData?.default_project_units === 'matric' ? 'mm' : 'in'})`}
                  id="standard-adornment-password"
                  type='number'
                  value={items?.product_data?.clearance?.left}
                  onChange={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        clearance: {
                          ...prevData.product_data.clearance,
                          left: e.target?.value
                        }
                      }
                    }));
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 38 || event.keyCode === 40) {
                      event.preventDefault();
                    }
                  }}
                />
              </FormControl>
              {items?.product_data?.clearance?.left !== itemData?.product?.clearance?.left && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.clearance?.left || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormControl size="small" fullWidth variant="outlined">
                <InputLabel htmlFor="standard-adornment-password">Right ({projectData?.default_project_units === 'matric' ? 'mm' : 'in'})</InputLabel>
                <OutlinedInput
                  label={`Right (${projectData?.default_project_units === 'matric' ? 'mm' : 'in'})`}
                  id="standard-adornment-password"
                  type='number'
                  value={items?.product_data?.clearance?.right}
                  onChange={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        clearance: {
                          ...prevData.product_data.clearance,
                          right: e.target?.value
                        }
                      }
                    }));
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 38 || event.keyCode === 40) {
                      event.preventDefault();
                    }
                  }}
                />
              </FormControl>
              {items?.product_data?.clearance?.right !== itemData?.product?.clearance?.right && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.clearance?.right || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormControl size="small" fullWidth variant="outlined">
                <InputLabel htmlFor="standard-adornment-password">Front ({projectData?.default_project_units === 'matric' ? 'mm' : 'in'})</InputLabel>
                <OutlinedInput
                  label={`Front (${projectData?.default_project_units === 'matric' ? 'mm' : 'in'})`}
                  id="standard-adornment-password"
                  type='number'
                  value={items?.product_data?.clearance?.front}
                  onChange={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        clearance: {
                          ...prevData.product_data.clearance,
                          front: e.target?.value
                        }
                      }
                    }));
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 38 || event.keyCode === 40) {
                      event.preventDefault();
                    }
                  }}
                />
              </FormControl>
              {items?.product_data?.clearance?.front !== itemData?.product?.clearance?.front && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.clearance?.front || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormControl size="small" fullWidth variant="outlined">
                <InputLabel htmlFor="standard-adornment-password">Back ({projectData?.default_project_units === 'matric' ? 'mm' : 'in'})</InputLabel>
                <OutlinedInput
                  label={`Back (${projectData?.default_project_units === 'matric' ? 'mm' : 'in'})`}
                  id="standard-adornment-password"
                  type='number'
                  value={items?.product_data?.clearance?.back}
                  onChange={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        clearance: {
                          ...prevData.product_data.clearance,
                          back: e.target?.value
                        }
                      }
                    }));
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 38 || event.keyCode === 40) {
                      event.preventDefault();
                    }
                  }}
                />
              </FormControl>
              {items?.product_data?.clearance?.back !== itemData?.product?.clearance?.back && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.clearance?.back || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormControl size="small" fullWidth variant="outlined">
                <InputLabel htmlFor="standard-adornment-password">Top ({projectData?.default_project_units === 'matric' ? 'mm' : 'in'})</InputLabel>
                <OutlinedInput
                  label={`Top (${projectData?.default_project_units === 'matric' ? 'mm' : 'in'})`}
                  id="standard-adornment-password"
                  type='number'
                  value={items?.product_data?.clearance?.top}
                  onChange={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        clearance: {
                          ...prevData.product_data.clearance,
                          top: e.target?.value
                        }
                      }
                    }));
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 38 || event.keyCode === 40) {
                      event.preventDefault();
                    }
                  }}
                />
              </FormControl>
              {items?.product_data?.clearance?.top !== itemData?.product?.clearance?.top && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.clearance?.top || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormControl size="small" fullWidth variant="outlined">
                <InputLabel htmlFor="standard-adornment-password">Bottom ({projectData?.default_project_units === 'matric' ? 'mm' : 'in'})</InputLabel>
                <OutlinedInput
                  label={`Bottom (${projectData?.default_project_units === 'matric' ? 'mm' : 'in'})`}
                  id="standard-adornment-password"
                  type='number'
                  value={items?.product_data?.clearance?.bottom}
                  onChange={(e) => {
                    setItems((prevData) => ({
                      ...prevData,
                      product_data: {
                        ...prevData.product_data,
                        clearance: {
                          ...prevData.product_data.clearance,
                          bottom: e.target?.value
                        }
                      }
                    }));
                  }}
                  onKeyDown={(event) => {
                    if (event.keyCode === 38 || event.keyCode === 40) {
                      event.preventDefault();
                    }
                  }}
                />
              </FormControl>
              {items?.product_data?.clearance?.bottom !== itemData?.product?.clearance?.bottom && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.clearance?.bottom || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={3}>
          <Box style={{ marginTop: 10, paddingBottom: 10 }}>
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Attributes</Typography>
          </Box>
          <Grid container spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={items?.product_data?.da_complient}
                      onClick={(e) => {
                        setItems((prevData) => ({
                          ...prevData,
                          product_data: {
                            ...prevData.product_data,
                            da_complient: e.target.checked
                          }
                        }));
                      }}
                    />}
                  label="DA Compliant"
                />
              </FormGroup>
              {items?.product_data?.da_complient !== itemData?.product?.da_complient && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.da_complient ? 'Yes' : 'No'}</DefaultTypo1>
                </Box>
              )}
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={items?.product_data?.green}
                      onClick={(e) => {
                        setItems((prevData) => ({
                          ...prevData,
                          product_data: {
                            ...prevData.product_data,
                            green: e.target.checked
                          }
                        }));
                      }}
                    />}
                  label="Green"
                />
              </FormGroup>
              {items?.product_data?.green !== itemData?.product?.green && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.green ? 'Yes' : 'No'}</DefaultTypo1>
                </Box>
              )}
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={items?.product_data?.antimicrobial}
                      onClick={(e) => {
                        setItems((prevData) => ({
                          ...prevData,
                          product_data: {
                            ...prevData.product_data,
                            antimicrobial: e.target.checked
                          }
                        }));
                      }}
                    />}
                  label="Anti-Microbial"
                />
              </FormGroup>
              {items?.product_data?.antimicrobial !== itemData?.product?.antimicrobial && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.antimicrobial ? 'Yes' : 'No'}</DefaultTypo1>
                </Box>
              )}
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={items?.product_data?.seismic}
                      onClick={(e) => {
                        setItems((prevData) => ({
                          ...prevData,
                          product_data: {
                            ...prevData.product_data,
                            seismic: e.target.checked
                          }
                        }));
                      }}
                    />}
                  label="Seismic"
                />
              </FormGroup>
              {items?.product_data?.seismic !== itemData?.product?.seismic && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.seismic ? 'Yes' : 'No'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Autocomplete
                value={Shielding.find((c) => c.value === items?.product_data?.Shielding) || null}
                id="combo-box-demo"
                size="small"
                fullWidth
                options={Shielding}
                getOptionLabel={(option) => option?.name}
                onChange={(event, newValue) => {
                  setItems((prevData) => ({
                    ...prevData,
                    product_data: {
                      ...prevData.product_data,
                      Shielding: newValue?.value || null
                    }
                  }));
                }}
                renderInput={(params) => <TextField fullWidth {...params} label="Shielding" name="Shielding" variant="outlined" />}
              />
              {items?.product_data?.Shielding !== itemData?.product?.Shielding && (
                <Box display="flex" alignItems="center">
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{Shielding.find((c) => c.value === itemData?.product?.Shielding)?.name || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default Physical;